import { Injectable } from '@angular/core';

declare let localStorage: any;

export const AUTH_TOKEN_KEY = 'tenthousandcoffees_token';
export const REFRESH_TOKEN_KEY = 'ttc_refresh_token';
export const TENANT_TOKEN_KEY = 'ttc_tenant_token';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  getItem(keyName: string) {
    return localStorage.getItem(keyName);
  }

  removeItem(keyName: string) {
    return localStorage.removeItem(keyName);
  }

  setItem(keyName: string, value: any) {
    return localStorage.setItem(keyName, value);
  }
}
